<template>
  <v-list-item @click.prevent="update" href="#">
    <v-list-item-icon>
      <v-icon>mdi-web</v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>{{ $t(`languages.${$i18n.locale === "en" ? "de" : "en"}`) }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import UpdateCurrentUserMutation from "@/gql/mutations/UpdateCurrentUserMutation.gql";

export default {
  methods: {
    async update() {
      this.$i18n.locale = this.$i18n.locale === "en" ? "de" : "en";
      this.$vuetify.lang.current = this.$i18n.locale;

      await this.$apollo.mutate({
        mutation: UpdateCurrentUserMutation,
        variables: {
          input: {
            language: this.$i18n.locale,
          },
        },
      });
    },
  },
};
</script>
